import React from 'react';

import IndicationAndSafetyPage from './IndicationAndSafetyPage';

function IndicationAndSafety({ inline_indications_ref, indicationId, safetyDataOverride, qsub }) {
    return (
        <div id='selected-indication'>
            <IndicationAndSafetyPage inline_indications_ref={inline_indications_ref} indicationId={indicationId} safetyDataOverride={safetyDataOverride} qsub={qsub} />
        </div>
    );
}

export default IndicationAndSafety;
